import React, {useEffect} from 'react';
import cx from 'classnames';
import qs from 'query-string';

const CalendlyWidget = ({
  type,
  href,
  className,
  style,
  values,
  hideLandingPageDetails = false,
  hideEventTypeDetails = false,
}) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  let url = qs.stringifyUrl({
    url: href,
    query: {
      hide_landing_page_details: hideLandingPageDetails ? 1 : undefined,
      hide_event_type_details: hideEventTypeDetails ? 1 : undefined,
      ...(values || {}),
    },
  });

  // Ensure protocol present or Calendly assumes relative URL
  if (!url.startsWith('http')) url = `https://${url}`;

  return (
    <div
      id={`calendly-${type}`}
      className={cx('calendly-inline-widget min-w-full', className)}
      style={style}
      data-url={url}
    />
  );
};

export default CalendlyWidget;
